import { reactToCrossAppLogoutCookieIfApplicable } from "@/cognito/crossAppLogoutCookie";
import { useUserStore } from "@/stores/user";
import { restorePersistedCompanySessionIfNeeded } from "@/utils/companySessionRestore";

/** Rehydrate Pinia before peer logout cookie match (avoids missing email/sub on cold tabs). */
export function reactToPeerLogoutWithRestoredSession(): void {
  const userStore = useUserStore();
  restorePersistedCompanySessionIfNeeded(userStore);
  reactToCrossAppLogoutCookieIfApplicable();
}
